import React, { useEffect } from "react"
import { connect } from "react-redux"
import { setBreadcrumbItems } from "../../store/actions"
import { Container } from "reactstrap"

const PagesBlank = (props) => {
  useEffect(() => {
    props.setBreadcrumbItems("Blank Page", [
      { title: "Extra Pages", link: "#" },
      { title: "Blank Page", link: "#" },
    ])
  }, [props])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0">Blank Page</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <h4 className="card-title">This is a blank page</h4>
                  <p className="card-text">
                    Use this page as a starter for your new awesome project.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  // Add any state you need here
})

export default connect(mapStateToProps, { setBreadcrumbItems })(PagesBlank)
